import { expandElement } from '../utils/helper.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class BfgProfileBrand extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	init() {
        const expandImpactLocationBtn = this.selector.querySelector('.js-impact-expand-location') as HTMLElement;
        const expandSubImpactBtn = this.selector.querySelector('.js-expand-sub-impact') as HTMLElement;
        if (expandImpactLocationBtn) {
            const wrapperSection = expandImpactLocationBtn.closest('#impact-location') as HTMLElement;
            const numberOfRestLocation = expandImpactLocationBtn.dataset.numberRestLocation;
            const showMoreText = `+ ${numberOfRestLocation} more`;
            expandImpactLocationBtn.addEventListener('click', () => expandElement(expandImpactLocationBtn, wrapperSection, showMoreText, 'Show less'));
        }
        if (expandSubImpactBtn) {
            const wrapperSection = expandSubImpactBtn.closest('#impact-areas-and-beneficiaries') as HTMLElement;
            const numberOfRestLocation = expandSubImpactBtn.dataset.numberRestSubImpact;
            const showMoreText = `+ ${numberOfRestLocation} more`;
            expandSubImpactBtn.addEventListener('click', () => expandElement(expandSubImpactBtn, wrapperSection, showMoreText, 'Show less'));
        }
	}
}

export default BfgProfileBrand;
